import { gql } from '@apollo/client'

/**
 * Archive all chats mutation
 */
export const ARCHIVE_ALL_CHATS = gql`
  mutation ArchiveAllChats {
    archiveAllChats {
      id
    }
  }
`
